import React from 'react';
import Card from './Card';
import {Data } from './Data';


const Plans = () => {
 // console.log(benefits[0].package[0]);
 // let food = Data[0].packaged;
 // let newArray = food.map((item) => {
 //  return `<p> ${item} </p>`;
  
  
 // })
 // console.log(newArray.join(""));
 
 
 return (
  <>
   <section className="container py-3 px-2 mt-2">
    <div className="plans-header pb-4">
     <p className="text-primary text-center work-text">
     Best Pricing
     </p>
     <h2 className="text-dark text-center work-text">
     Our Pricing Plans
     </h2>
    </div>
    <div className="row mt-3">
   {Data.map((item,index)=> {
    return (
     <div className="col-md-4">
      <Card {...item} key={index} className="pt-3"/>
     </div>
    )
   })} 
   
    </div>
    
   </section>
   {/* <HeroSection /> */}
   {/* <Cards /> */}
   {/* <Footer /> */}
  </>
 )
}

export default Plans